import { api } from '../../../shared/api/client';

export const changePassword = (userId, password, rePassword) => api.post('/partner/changePassword', {
    userId,
    password,
    rePassword,
});
export const cancelGoogleSecret = () => api.get('/profile/cancelGoogleSecret');
export const getFees = (userId = {}) => api.get('user/fee/getFees', { params: { user_id: userId } });
export const updateFee = (data = {}) => api.post('user/fee/updateFee', data);
export const getAccountDetail = () => api.post('getAccountDetail', {});
export const getApiToken = () => api.get('/user/getApiToken');
export const getBalance = () => api.get('/getBalance');
export const getGoogleSecretKey = () => api.get('/profile/getGoogleSecretKey');
export const getSecurity = () => api.get('/profile/getSecurity');
export const getActivityLogs = (params = {}) => api.post('/log-activity/getActivityLogs', params);
export const getLoginLogs = (params = {}) => api.post('/log-activity/getLoginLogs', params);
export const updatePassword = (password, newPassword) => api.post('/profile/updatePassword', {
    password,
    newPassword,
});
export const updateProfile = (name, email) => api.post('/profile/updateProfile', { name, email });
export const verifyGoogleSecret = (otp) => api.post('/profile/verifyGoogleSecret', { otp });
